<template>
  <component
    :is="icon"
    v-if="isObject(icon)"
    :class="[icon.class, color, size]"
    v-bind="aria"
  />
  <i
    v-else
    :class="[set, icon, 'fa-fw', color, size]"
    v-bind="aria"
  />
</template>

<script setup>
import icons from "@/icons"
import { camelCase, isObject } from "lodash-es"
import { computed } from "vue"

const props = defineProps({
  name: { type: String, required: true },
  color: { type: String },
  size: { type: String },
  ariaLabel: { type: String },
  set: { type: String, default: "solid" },
})

const aria = computed(() => {
  return {
    "aria-hidden": !props.ariaLabel,
    "aria-label": props.ariaLabel,
  }
})

const colors = {
  gray: "text-gray-300 dark:text-gray-500",
  green: "text-green",
  orange: "text-orange-600",
  red: "text-red",
  white: "text-white",
  yellow: "text-yellow",
}

const sizes = {
  "sm": "text-sm",
  "md": "text-md",
  "lg": "text-lg",
  "xl": "text-xl",
  "2xl": "text-2xl",
  "3xl": "text-3xl",
  "4xl": "text-4xl",
  "5xl": "text-5xl",
  "6xl": "text-6xl",
}

const sets = {
  brands: "fa-brands",
  regular: "fa-regular",
  solid: "fa-solid",
  duotone: "fa-duotone",
  light: "fa-light",
}

const color = computed(() => colors[props.color])

const icon = computed(() => icons[camelCase(props.name)] || props.name)

const size = computed(() => sizes[props.size])

const set = computed(() => sets[props.set])
</script>
